/**
 * @generated SignedSource<<93c197a750a8108a2f818d614641210d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SageSignupFlow_viewer$data = {
  readonly id: string;
  readonly csrfToken: string | null;
  readonly actualPersonId: string | null;
  readonly email: string | null;
  readonly company: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "SageSignupFlow_viewer";
};
export type SageSignupFlow_viewer$key = {
  readonly " $data"?: SageSignupFlow_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SageSignupFlow_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SageSignupFlow_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "csrfToken",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "262cfc5b2a0abec992ce4a2a09d51dff";

export default node;
